import { snakeToCamel } from '../../../utils/object'

import Model from '../models'

import PreferenceAPI from './api'

export default class Preference extends Model {
  static api = PreferenceAPI.create(Preference)
  static readOnlyFields = ['id']

  constructor({ id = null, name } = {}) {
    super()
    Object.assign(this, {
      id,
      name,
    })
  }

  static create(opts = {}) {
    return new Preference(opts)
  }

  static fromAPI(json = {}) {
    return new Preference(snakeToCamel(json))
  }

  copy() {
    return new Preference(this)
  }
}
